import { render, staticRenderFns } from "./NavShare.vue?vue&type=template&id=35527dec&scoped=true&"
import script from "./NavShare.vue?vue&type=script&lang=js&"
export * from "./NavShare.vue?vue&type=script&lang=js&"
import style0 from "./NavShare.vue?vue&type=style&index=0&id=35527dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35527dec",
  null
  
)

export default component.exports